import { getChatScriptById } from '../../apiClient';
import { useQuery } from '@tanstack/react-query';

const useGetChatScriptByIdQuery = (scriptId, enabled = true) =>
    useQuery({
        queryKey: ['chat_script', scriptId],
        queryFn: async () => getChatScriptById(scriptId),
        throwOnError: (error) => false,
        refetchOnMount: false,
        retryOnMount: false,
        enabled: enabled && Number.isInteger(Number.parseInt(scriptId)),
    });
export default useGetChatScriptByIdQuery;
